import { render, staticRenderFns } from "./not-qualification-toast.vue?vue&type=template&id=28dd60c7&scoped=true&"
import script from "./not-qualification-toast.vue?vue&type=script&lang=js&"
export * from "./not-qualification-toast.vue?vue&type=script&lang=js&"
import style0 from "./not-qualification-toast.vue?vue&type=style&index=0&id=28dd60c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd60c7",
  null
  
)

export default component.exports